import { gql } from '@apollo/client';

export * from './markAsUnreadTasks.mutation.generated';

export const MARK_AS_UNREAD_TASKS = gql`
  mutation markAsUnreadTasks($taskIds: [ID!]!) {
    markAsUnreadTasks(input: { taskIds: $taskIds }) {
      errors
      success
      tasks {
        id
      }
    }
  }
`;
